import React from "react";
import Row from "antd/lib/row";
import Col from "antd/lib/col";
import Image from "antd/lib/image";
import kafkaEbook from "../images/kafka_ebook.png";
import Typography from "antd/lib/typography";
import Divider from "antd/lib/divider";

const { Paragraph } = Typography;

const Handbook: React.FC = () => (
    <>
        <Divider>Master Apache Kafka: Download eBook</Divider>

        <Row justify="center">
            <Col span={12}>
                <Paragraph>
                    Unlock the full potential of Apache Kafka with our ebook,
                    offering insights from Confluent, the driving force behind
                    Kafka’s development.
                </Paragraph>
                <Paragraph>
                    Elevate your data pipeline, understand its architecture, and
                    explore strategic use cases. Download now for a
                    comprehensive guide to Kafka’s transformative power!
                </Paragraph>
            </Col>
            <Col span={12}>
                <a
                    href="https://softwaremill.com/ebooks/start-with-apache-kafka-ebook/"
                    target="_blank"
                    rel="noreferrer"
                >
                    <Image
                        src={kafkaEbook}
                        alt="Kafka e-book"
                        preview={false}
                    />
                </a>
                <Row justify="center">
                    <a
                        href="https://softwaremill.com/ebooks/start-with-apache-kafka-ebook/"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Visit website
                    </a>
                </Row>
            </Col>
        </Row>
    </>
);

export default Handbook;
